import { ContactCard } from "@/components/ui/contact/contactCard";
import {
  BusinessSection,
  CrossBorderEcConsultingSection,
  DevelopmentSection,
  ShopifyAppSection,
} from "@/components/ui/service/businessSection";

export function ServicePage() {
  return (
    <>
      {/* Page header */}
      <section className="border-b border-border/60 px-6 py-16 md:px-12">
        <div className="mx-auto max-w-3xl">
          <p className="font-mono text-xs uppercase tracking-[0.3em] text-muted-foreground">
            Services
          </p>
          <h1 className="mt-4 font-serif text-4xl font-light leading-tight tracking-tight text-foreground md:text-5xl">
            サービス
          </h1>
          <p className="mt-6 max-w-xl text-muted-foreground leading-relaxed">
            課題を伺い、先端技術を用いて解決するサービスを提供します。
          </p>
        </div>
      </section>

      <CrossBorderEcConsultingSection />
      <ShopifyAppSection />
      <BusinessSection />
      <DevelopmentSection />

      {/* Approach */}
      <section className="border-t border-border/60 bg-muted/20 px-6 py-20 md:px-12">
        <div className="mx-auto max-w-4xl">
          <h2 className="font-serif text-2xl font-light tracking-tight text-foreground md:text-3xl">
            段取りの一例
          </h2>
          <p className="mt-8 max-w-2xl text-foreground/90 leading-relaxed">
            現場の声とデータを重視し、組織や業界に深く入り込んだ伴走型の支援を行います。戦略の「描き方」だけでなく「実現の仕方」まで、
            一貫してサポートします。
          </p>
          <div className="relative mt-8">
            <div
              className="absolute left-3 top-0 bottom-0 w-px bg-gradient-to-b from-border via-border to-transparent"
              aria-hidden
            />
            <ul className="space-y-8">
              {[
                "課題のヒアリング",
                "ご提案",
                "スケジュール・体制の決定",
                "お見積り",
                "契約",
                "キックオフ",
                "定期打ち合わせ、進捗報告",
              ].map((title, i) => (
                <li
                  key={title}
                  className="relative flex gap-6 pl-8 sm:pl-10"
                >
                  <span
                    className="absolute left-3 top-[0.35rem] h-2 w-2 -translate-x-1/2 shrink-0 rounded-full border border-border bg-background shadow-sm"
                    aria-hidden
                  />
                  <div className="min-w-0 flex-1 pb-1">
                    <p className="text-[15px] leading-snug text-foreground/90">
                      {i + 1}. {title}
                    </p>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      <section className="px-6 py-20 md:px-12">
        <div className="mx-auto max-w-4xl">
          <ContactCard />
        </div>
      </section>
    </>
  );
}
